let branchCircles = [];
let circleLabels = [];

const RADII = [
  { r: 5000, text: "5 km" },
  { r: 10000, text: "10 km" },
  { r: 15000, text: "15 km" },
];

export const drawBranchCircles = (map, center) => {
  if (!map || !window.google) return;

  branchCircles.forEach((c) => c.setMap(null));
  circleLabels.forEach((l) => l.setMap(null));
  branchCircles = [];
  circleLabels = [];

  RADII.forEach(({ r, text }, index) => {
    const circle = new window.google.maps.Circle({
      map,
      center,
      radius: r,
      strokeColor: ["#1a73e8", "#34a853", "#ea4335"][index],
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillOpacity: 0.05,
      clickable: false,
    });

    branchCircles.push(circle);

    const label = new window.google.maps.OverlayView();

    label.onAdd = function () {
      const div = document.createElement("div");
      div.innerText = text;
      div.style.position = "absolute";
      div.style.fontSize = "11px";
      div.style.fontWeight = "600";
      div.style.padding = "2px 6px";
      div.style.borderRadius = "4px";
      div.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
      div.style.whiteSpace = "nowrap";
      div.style.color = "#000";
      this.div = div;

      this.getPanes().overlayMouseTarget.appendChild(div);
    };

    label.draw = function () {
      const projection = this.getProjection();
      if (!projection) return;

      const north = window.google.maps.geometry.spherical.computeOffset(
        center,
        r,
        0
      );

      const pos = projection.fromLatLngToDivPixel(north);
      this.div.style.left = `${pos.x}px`;
      this.div.style.top = `${pos.y}px`;
    };

    label.onRemove = function () {
      if (this.div) this.div.remove();
    };

    label.setMap(map);
    circleLabels.push(label);
  });
};

export const clearBranchCircles = () => {
  branchCircles.forEach((c) => c.setMap(null));
  circleLabels.forEach((l) => l.setMap(null));
  branchCircles = [];
  circleLabels = [];
};
